// extracted by css-extract-rspack-plugin
export default {"baseBox":"baseBox-H5yN65","historyBox":"historyBox-FkCNBW"};